const AI_CAMPAIGN_TYPES = ["AUTOMATED", "AUTO_RESPONSE"];

/**
 * Check if AI feedback buttons should be shown for a message or email.
 * Only applies to outbound messages (direction "TO_LEAD").
 *
 * @param {Object} params
 * @param {string} [params.direction] - Message direction (e.g., "TO_LEAD", "FROM_LEAD")
 * @param {string} [params.contentType] - The message content type (e.g., "AI Response To Lead")
 * @param {string} [params.campaignType] - The campaign type (e.g., "AUTOMATED", "AUTO_RESPONSE")
 * @param {string|Date} [params.dateSent] - The date sent value
 * @returns {boolean}
 */
export const shouldShowAiFeedback = ({ direction, contentType, campaignType, dateSent } = {}) => {
  // if (direction !== "TO_LEAD") return false;
  if (contentType === "AI Response To Lead") return true;
  if (AI_CAMPAIGN_TYPES.includes(campaignType) && dateSent) return true;
  return false;
};

/**
 * Comparator for feedback reason / topic options: sorts alphabetically by name
 * but always keeps an "Other" option pinned to the end of the list. Use with
 * `Array.prototype.sort` on any list of `{ name }` options.
 *
 * @param {{ name?: string }} a
 * @param {{ name?: string }} b
 * @returns {number}
 */
export const compareReasonsOtherLast = (a, b) => {
  const aOther = a?.name?.trim().toLowerCase() === "other";
  const bOther = b?.name?.trim().toLowerCase() === "other";
  if (aOther !== bOther) return aOther ? 1 : -1;
  return (a?.name || "").localeCompare(b?.name || "");
};
